/**
 * @file Contributor dashboard UI — pages/Dashboard/Contributor/Stages/ContributorDetails/components/ContributorDetailsFieldRenderer.tsx.
 */

import React from "react";
import { FormField, DropdownOption } from "../../../../../../interfaces/formInterfaces";
import TextInput from "../../../../../../components/common/TextInput";
import Dropdown from "../../../../../../components/common/Dropdown";
import { getContributorTextInputHtmlProps } from "../../../../../../utils/contributorFormFieldInputProps";

interface ContributorDetailsFieldRendererProps {
  field: FormField;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  error?: string;
  disabled?: boolean;
  isBackgroundOtherEnabled?: boolean;
}

const ContributorDetailsFieldRenderer: React.FC<ContributorDetailsFieldRendererProps> = ({
  field,
  value,
  onChange,
  error,
  disabled = false,
  isBackgroundOtherEnabled = false,
}) => {
  // Handle background_other field - disable if background is not "Other"
  const isFieldDisabled = field.name === "background_other" 
    ? !isBackgroundOtherEnabled || disabled
    : disabled;

  if (field.type === "TEXT" || field.type === "EMAIL") {
    const h = getContributorTextInputHtmlProps(field);
    return (
      <TextInput
        label={field.label}
        name={field.name}
        value={value}
        onChange={onChange}
        required={field.isMandatory}
        disabled={isFieldDisabled}
        placeholder={field.placeholder || ""}
        infoText={field.infoText}
        error={error}
        type={(h.type as string) ?? "text"}
        maxLength={h.maxLength}
        min={h.min}
        max={h.max}
        step={h.step}
      />
    );
  }

  if (field.type === "DROPDOWN") {
    const options: DropdownOption[] = field.dropdown?.options || [];

    return (
      <Dropdown
        label={field.label}
        name={field.name}
        options={options.map((o) => ({
          label: o.label,
          value: o.value,
        }))}
        value={value}
        onChange={onChange}
        required={field.isMandatory}
        disabled={isFieldDisabled}
        infoText={field.infoText}
        error={error}
      />
    );
  }

  return null;
};

/** React component — Contributor Details Field Renderer. */
export default ContributorDetailsFieldRenderer;

